<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name {{ keyName }}
      span.validation-label(v-if="required == true") 必須

    .register-value 
      // year
      select#year.register-form.year(name="year" v-model="_year" v-validate="{ required: required }" placeholder="年" data-vv-as="年"
        :class="{ noinput: (required == true && !_year) }" :options="_yearOptions")
        option(v-for="option in _yearOptions" :value="option.value") {{ option.text }}
      span 年

      // month
      select#month.register-form.month(name="month" v-model="_month" v-validate="{ required: required }" placeholder="月" data-vv-as="月"
        :class="{ noinput: (required == true && !_month) }")
        option(v-for="n in 12") {{ n }}
      span 月

      // day
      select#day.register-form.day(name="day" v-model="_day" v-validate="{ required: required }" placeholder="日" data-vv-as="日"
        :class="{ noinput: (required == true && !_day) }")
        option(v-for="n in 31") {{ n }}
      span 日

    .error-messages
      div(v-if="errors.has('year')")
        label.error-message {{ errors.first('year') }}
      div(v-if="errors.has('month')")
        label.error-message {{ errors.first('month') }}
      div(v-if="errors.has('day')")
        label.error-message {{ errors.first('day') }}
      div(v-if="errors.has('date')")
        label.error-message {{ errors.first('date') }}
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * 入力要素コンポーネント(年月日分割入力)
 *
 * - 年月日の分割入力をサポートする
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputSplitDate extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 項目名 */
  @Prop({ required: true, type: String })
  private keyName!: string;

  /** 必須か */
  @Prop({
    default: () => {
      return false;
    },
    type: Boolean
  })
  private required!: boolean;

  /** veevalidateに渡すバリデーション項目名(date用) */
  @Prop({
    default: () => {
      return "年月日";
    },
    type: String
  })
  private validationDateKeyName!: string;

  /** 年 */
  @Prop({
    default: () => {
      ("");
    }
  })
  private year!: string;

  /** 月 */
  @Prop({
    default: () => {
      ("");
    }
  })
  private month!: string;

  /** 日 */
  @Prop({
    default: () => {
      ("");
    }
  })
  private day!: string;

  get _yearOptions(): Array<{ value: number; text: string }> {
    let options: Array<{ text: string; value: number }> = [];

    const currentYear: number = this.$dateUtil.convertDateToNumber(new Date(), "yyyy");
    const startPosition: number = currentYear - 120;
    const count: number = 120;

    for (let i = 0; i <= count; i++) {
      const year: number = startPosition + i;
      const date = new Date(year, 11, 31, 0, 0);
      const intlOptions: Intl.DateTimeFormatOptions = { year: "numeric" };
      const jpYear: string = new Intl.DateTimeFormat("ja-JP-u-ca-japanese", intlOptions).format(date).slice(0, -1); // 年が重複するので最終文字だけ削除;

      options.push({
        text: `${year}（${jpYear}）`,
        value: year
      });
    }

    return options;
  }

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _year(): string {
    if (this.year) {
      return this.year;
    } else {
      return "";
    }
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _year(value: string) {
    this.$emit("update:year", value);
    return;
  }

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _month(): string {
    if (this.month) {
      return this.month;
    } else {
      return "";
    }
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _month(value: string) {
    this.$emit("update:month", value);
    return;
  }

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _day(): string {
    if (this.day) {
      return this.day;
    } else {
      return "";
    }
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _day(value: string) {
    this.$emit("update:day", value);
    return;
  }
}
</script>
